import {
  LINE_OF_EFFORT_ADDED,
  LINE_OF_EFFORT_DELETED,
  LINE_OF_EFFORT_EDITED,
  LINE_OF_EFFORT_SET,
} from 'src/app/redux/redux-types';
import { reduxLineOfEffortTypes } from 'src/types';

export const lineOfEffortDefaultState: reduxLineOfEffortTypes.StateType = {
  lineOfEffortList: [],
};

export const lineOfEffortReducer = (
  state = lineOfEffortDefaultState,
  action: reduxLineOfEffortTypes.ActionType,
): reduxLineOfEffortTypes.StateType => {
  switch (action.type) {
    case LINE_OF_EFFORT_SET:
      return {
        ...state,
        lineOfEffortList: action.payload,
      };
    case LINE_OF_EFFORT_ADDED:
      const exists = state.lineOfEffortList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        lineOfEffortList: [action.payload, ...state.lineOfEffortList],
      };
    case LINE_OF_EFFORT_EDITED:
      const updateIndex = state.lineOfEffortList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        lineOfEffortList: [
          ...state.lineOfEffortList.slice(0, updateIndex),
          action.payload,
          ...state.lineOfEffortList.slice(updateIndex + 1),
        ],
      };
    case LINE_OF_EFFORT_DELETED:
      return {
        ...state,
        lineOfEffortList: state.lineOfEffortList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
